import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Layout Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import WhatsAppFloating from './components/common/WhatsAppFloating';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import WebDesign from './pages/WebDesign';
import SocialMedia from './pages/SocialMedia';
import PaidAds from './pages/PaidAds';
import Contact from './pages/Contact';

// Styles
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          {/* Header with Navigation */}
          <Header />

          {/* Main Content Routes */}
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/web-design" element={<WebDesign />} />
              <Route path="/services/social-media" element={<SocialMedia />} />
              <Route path="/services/paid-ads" element={<PaidAds />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>

          {/* Footer */}
          <Footer />

          {/* WhatsApp Floating Button */}
          <WhatsAppFloating />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
